"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const button_1 = __importDefault(require("@kyruus/button"));
const ui_theme_1 = __importDefault(require("@kyruus/ui-theme"));
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const styles_1 = require("./styles");
const tracking_1 = require("../constants/tracking");
const ModalLink = ({ addOnType, onTrack, sentence, modalContent }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const openModal = () => {
        if (typeof onTrack === 'function') {
            onTrack(tracking_1.USER_ACTION_LAUNCHED_ADDON_MODAL, { field_name: addOnType });
        }
        setIsOpen(true);
    };
    const closeModal = () => setIsOpen(false);
    const paragraphedBody = modalContent.body && Array.isArray(modalContent.body)
        ? modalContent.body.map((p, index) => (
        // indexes are fine for keys if the order of items won't change
        // eslint-disable-next-line react/no-array-index-key
        react_1.default.createElement("p", { key: index }, p)))
        : modalContent.body;
    const isModalFullScreen = (0, useMediaQuery_1.default)(`(max-width:${ui_theme_1.default.screen_medium})`);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(styles_1.StyledButton, { "data-testid": `addon-modal-link-${addOnType}`, mode: "flat", type: "button", onClick: openModal }, sentence),
        react_1.default.createElement(styles_1.StyledModal, { title: modalContent.title, body: paragraphedBody, "data-testid": `addon-modal-content-${addOnType}`, primaryButton: 
            // eslint-disable-next-line react/jsx-wrap-multilines
            react_1.default.createElement(button_1.default, { "data-testid": `addon-modal-close-${addOnType}`, mode: "primary", onClick: closeModal }, "OK"), maxWidth: "xs", open: isOpen, onClose: closeModal, onBackdropClick: closeModal, onEscapeKeyDown: closeModal, fullScreen: isModalFullScreen })));
};
ModalLink.propTypes = {
    addOnType: prop_types_1.default.string.isRequired,
    sentence: prop_types_1.default.string.isRequired,
    modalContent: prop_types_1.default.shape({
        title: prop_types_1.default.string.isRequired,
        body: prop_types_1.default.arrayOf(prop_types_1.default.string).isRequired
    }).isRequired,
    /** signature onTrack(eventName: string, eventData = {[key:string]:string}) */
    onTrack: prop_types_1.default.func
};
exports.default = ModalLink;
//# sourceMappingURL=ModalLink.js.map